import {CheckCircleIcon, Text, View} from 'native-base';
import React from 'react';
import {useTheme} from 'styled-components/native';

interface OfferStatePropTypes {
  status: string;
  size: number;
  isListView?: boolean;
}

const OfferState: React.FC<OfferStatePropTypes> = ({
  status,
  size,
  isListView = false,
}) => {
  const theme = useTheme();
  const {confirm} = theme.colors;

  return (
    <View
      width={isListView ? null : '100%'}
      alignItems="center"
      flexDirection="row"
      justifyContent="center"
      mt={isListView ? 0 : 4}>
      <CheckCircleIcon color={confirm} size={size} marginRight={1} />
      <Text color={confirm} fontWeight="bold" fontSize={size}>
        {status.toUpperCase()}
      </Text>
    </View>
  );
};

export default OfferState;
